import { deactivateEmployeeReportsTo } from "actions/Utilities/EmployeeReportsTo";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { employeeReportsToReFetching } from "../atoms/atoms";

export default function useDeactivateEmployeeReportsTo() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    employeeReportsToReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deactivateEmployeeReportsTo(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Employee Reports To failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Employee Reports To Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Employee Reports To Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Employee Reports To failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Employee Reports To not found":
              toast.fire(
                "Disabling Employee Reports To failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Employee Reports To failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Employee Reports To failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
